import React from 'react';
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
} from '@mui/material';

function UserDashboard() {
  const enrolledCourses = [
    {
      id: 1,
      title: 'Full Stack Web Development',
      progress: '60%',
      nextLesson: 'React Components',
    },
    {
      id: 2,
      title: 'Data Science Fundamentals',
      progress: '30%',
      nextLesson: 'Python for Data Analysis',
    },
  ];

  const upcomingSchedule = [
    {
      id: 1,
      title: 'Live Session: React Hooks',
      date: '2025-01-28',
      time: '10:00 AM',
    },
    {
      id: 2,
      title: 'Project Submission Deadline',
      date: '2025-01-30',
      time: '11:59 PM',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Welcome back, Student!
      </Typography>

      <Grid container spacing={3}>
        {/* Enrolled Courses */}
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              My Courses
            </Typography>
            <Grid container spacing={2}>
              {enrolledCourses.map((course) => (
                <Grid item xs={12} sm={6} key={course.id}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        {course.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Progress: {course.progress}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Next Lesson: {course.nextLesson}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Grid>

        {/* Schedule */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Upcoming Schedule
            </Typography>
            <List>
              {upcomingSchedule.map((item) => (
                <ListItem key={item.id}>
                  <ListItemText
                    primary={item.title}
                    secondary={`${item.date} at ${item.time}`}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>

        {/* Progress Overview */}
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Learning Progress
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-around', py: 2 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h4">2</Typography>
                <Typography variant="body2" color="text.secondary">
                  Courses in Progress
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h4">12</Typography>
                <Typography variant="body2" color="text.secondary">
                  Assignments Completed
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h4">45</Typography>
                <Typography variant="body2" color="text.secondary">
                  Hours Spent Learning
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default UserDashboard;
